import { render, staticRenderFns } from "./EquipmentDistributionArea.vue?vue&type=template&id=22610b12&scoped=true&"
import script from "./EquipmentDistributionArea.vue?vue&type=script&lang=js&"
export * from "./EquipmentDistributionArea.vue?vue&type=script&lang=js&"
import style0 from "./EquipmentDistributionArea.vue?vue&type=style&index=0&id=22610b12&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22610b12",
  null
  
)

export default component.exports